import { EditOutlined } from '@ant-design/icons';
import PermitSuperAdmin from '@zeus/core/PermitSuperAdmin';
import { useAuth } from '_/contexts/AuthContext';
import { useTopHeader } from '_/contexts/LayoutContext';
import { useOrganization } from '_/contexts/OrganizationContext';
import NewOrganizationModal from '_/features/organizations/forms/NewOrganizationModal';
import { Card, Typography, Space } from 'antd';
import React, { ReactElement, useCallback, useEffect, useState } from 'react';

const { Text } = Typography;

function OrgSettings(): ReactElement {
  const { selectedOrganization: organization, selectedOrgSlug } = useOrganization();
  const { isSuperAdmin } = useAuth();
  const { setBreadcrumbs, setActionButtons } = useTopHeader();
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const handleEdit = useCallback(() => {
    setIsEditModalOpen(true);
  }, []);

  // Set up header with breadcrumbs and action buttons
  useEffect(() => {
    setBreadcrumbs([
      { title: 'Organizations', href: '/orgs' },
      { title: organization?.name || '', href: `/orgs/${selectedOrgSlug}` },
      { title: 'Settings' },
    ]);

    if (isSuperAdmin) {
      setActionButtons([
        {
          onClick: handleEdit,
          icon: <EditOutlined />,
          label: 'Edit Organization',
        },
      ]);
    }

    return () => {
      setBreadcrumbs([]);
      setActionButtons([]);
    };
  }, [setBreadcrumbs, setActionButtons, organization, selectedOrgSlug, isSuperAdmin, handleEdit]);

  return (
    <>
      <div style={{ maxWidth: 600 }}>
        <Card title="General">
          <Space direction="vertical" style={{ width: '100%' }}>
            <div>
              <Text type="secondary" style={{ fontSize: 12 }}>
                Org Name
              </Text>
              <div style={{ marginTop: 4 }}>
                <Text>{organization?.name || '-'}</Text>
              </div>
            </div>

            <div>
              <Text type="secondary" style={{ fontSize: 12 }}>
                Slug/Id
              </Text>
              <div style={{ marginTop: 4 }}>
                <Text>{organization?.slug || '-'}</Text>
              </div>
            </div>

            <div>
              <Text type="secondary" style={{ fontSize: 12 }}>
                Id
              </Text>
              <div style={{ marginTop: 4 }}>
                <Text>{organization?.id || '-'}</Text>
              </div>
            </div>

            <PermitSuperAdmin>
              <div>
                <Text type="secondary" style={{ fontSize: 12 }}>
                  Legacy Platform ID
                </Text>
                <div style={{ marginTop: 4 }}>
                  <Text>{organization?.legacyPlatformId || '-'}</Text>
                </div>
              </div>
            </PermitSuperAdmin>
          </Space>
        </Card>
      </div>

      <NewOrganizationModal
        open={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        orgSlug={selectedOrgSlug || undefined}
      />
    </>
  );
}

export default OrgSettings;
